<template>
  <div class="research_group_container" v-if="researchGroupCharacter === 'leader'">
    <div class="hd research-background-color">
      <span class="icon icon-left navshare" @click="goBack" v-if="!isWapp"></span>
      <span class="header_title">注册联系人</span>
    </div>
    <div class="box">
      <div class= "box_1">
        <div class="main">
        <div class="outer_3">
          <div class="outer_attr">
            <div class="group">
              <div class="attr_name">姓名</div>
              <div class="wrap_approvetype">
                <input class="input_text" v-model.trim="registerName" id="search_name" type="text" placeholder="请输入姓名">
              </div>
            </div>
            <div class="container"><div class="empty" /></div>
          </div>
          <div class="outer_attr">
            <div class="group">
              <div class="attr_name">手机号</div>
              <div class="wrap_approvetype">
                <input class="input_text" v-model.trim="registerMobile" id="search_mobile" type="text" placeholder="请输入手机号">
              </div>
              </div>
            <div class="container"><div class="empty" /></div>
          </div>
          <div class="outer_attr">
            <div class="group">
              <div class="attr_name">邮箱</div>
              <div class="wrap_approvetype">
                <input class="input_text" v-model.trim="registerEmail" id="search_email" type="text" placeholder="请输入邮箱">
              </div>
            </div>
            <div class="container"><div class="empty" /></div>
          </div>
          <div class="outer_attr">
            <div class="group">
              <span class="attr_name">单位</span>
              <div class="wrap_approvetype">
                <input class="input_text"
                       readonly="readonly"
                       unselectable="on"
                       v-model.trim="enterprise.enterpriseName"
                       id="search_enterpriseName" type="text" placeholder="请选择单位">
<!--                <svg t="1583809028111" class="liveiconput" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1461" width="200" height="200"><path d="M279.937024 896.052224L743.875584 537.604096c0 0 25.778176-25.55392 0-51.207168-41.105408-40.80640001-442.91072-358.449152-463.93753599-358.449152-25.35424 25.201664 0 51.207168-1e-8 51.207168L692.31616 512l-412.379136 332.845056C279.937024 844.845056 254.582784 870.85056 279.937024 896.052224z" fill="#929292" p-id="1462"></path></svg>-->
              </div>
            </div>
            <div class="container"><div class="empty" /></div>
          </div>
<!--          <div class="outer_attr" v-if="ifShowDepartment">-->
<!--            <div class="group">-->
<!--              <span class="attr_name">科室</span>-->
<!--              <div class="wrap_approvetype" @click="toggleShowDepartmentBox">-->
<!--                <input class="input_text"-->
<!--                       readonly="readonly"-->
<!--                       unselectable="on"-->
<!--                       v-model.trim="department.enterpriseName"-->
<!--                       id="search_departmentName" type="text" placeholder="请选择科室">-->
<!--                <svg t="1583809028111" class="liveiconput" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1461" width="200" height="200"><path d="M279.937024 896.052224L743.875584 537.604096c0 0 25.778176-25.55392 0-51.207168-41.105408-40.80640001-442.91072-358.449152-463.93753599-358.449152-25.35424 25.201664 0 51.207168-1e-8 51.207168L692.31616 512l-412.379136 332.845056C279.937024 844.845056 254.582784 870.85056 279.937024 896.052224z" fill="#929292" p-id="1462"></path></svg>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="container"><div class="empty" /></div>-->
<!--          </div>-->
          <div class="block_2">
              <label class="label-checkbox item-content">
                <input type="radio" class="radio-input-attr" :checked="agreeStatus" name="attr_agree" value="">
                <div class="item-media" @click="agreeStatus = !agreeStatus">
                  <i class="icon icon-form-checkbox i-style"></i>
                  <span class="agreement research-font-color" v-if="agreeStatus">已阅读并同意</span>
                  <span class="desc" v-else>已阅读并同意</span>
                </div>
              </label>
              <u class="agreement research-font-color" @click="toggleResearchGroupRemindBox">《吉凯基因淘基因用户注册协议》</u>
          </div>
        </div>
      </div>
        <div class="ft research-background-color" @click="register">
        <span class="addMember">注册</span>
      </div>
      </div>
    </div>
    <ResearchGroupRemindBox :remindParams="remindParams" v-if="showResearchGroupRemindBox" @toggleShow="toggleResearchGroupRemindBox"/>
    <FirstLevelEnterpriseBox v-if="showFirstLevelEnterpriseBox" @toggleShow="toggleShowFirstLevelEnterpriseBox" @update="updateFirstLevelEnterprise"/>
    <DepartmentBox v-if="showDepartmentBox" :enterpriseNo="enterprise.enterpriseNo" @toggleShow="toggleShowDepartmentBox" @update="updateDepartment"/>
  </div>
</template>
<script>
import {mapGetters} from 'vuex'
import $ from 'jquery'
import ResearchGroupRemindBox from './../researchGroupComponents/ResearchGroupRemindBox'
import FirstLevelEnterpriseBox from './../researchGroupComponents/FirstLevelEnterpriseBox'
import DepartmentBox from '../researchGroupComponents/DepartmentBox'
import EMKT from '../../../../emkt'
export default {
  data () {
    return {
      registerMobile: this.$route.query.mobile,
      registerName: this.$route.query.name,
      registerEmail: '',
      showFirstLevelEnterpriseBox: false,
      showDepartmentBox: false,
      showResearchGroupRemindBox: false,
      remindParams: {
        register: true
      },
      agreeStatus: true,
      enterprise: {},
      department: {},
      error: '',
      isWapp: EMKT.isWapp
    }
  },
  mounted () {
    if (this.hasLogin && this.displayChosenResearchGroup) {
      this.enterprise = {
        'enterpriseName': this.displayChosenResearchGroup.firstLevelEnterpriseName,
        'enterpriseNo': this.displayChosenResearchGroup.firstLevelEnterpriseNo
      }
      this.department = {
        'enterpriseName': this.displayChosenResearchGroup.secondLevelEnterpriseName,
        'enterpriseNo': this.displayChosenResearchGroup.secondLevelEnterpriseNo
      }
    }
  },
  computed: {
    ...mapGetters([
      'displayChosenResearchGroup', 'customerNo', 'hasLogin', 'researchGroupCharacter'
    ])
    // ifShowDepartment () {
    //   if (this.enterprise.enterpriseName && this.enterprise.enterpriseName.includes('医院')) return true
    //   return false
    // }
  },
  components: {
    ResearchGroupRemindBox, FirstLevelEnterpriseBox, DepartmentBox
  },
  methods: {
    goBack () {
      this.$router.go(-1)
    },
    validatemobile (mobile) {
      if (mobile.length === 0) {
        $.toast('手机号码不能为空')
        return false
      }
      let myreg = /^1[3-9]{1}[0-9]{9}$/
      if (mobile.length !== 11 || !myreg.test(mobile)) {
        $.toast('请输入有效的手机号码')
        return false
      }
      return true
    },
    toggleShowFirstLevelEnterpriseBox () {
      this.showFirstLevelEnterpriseBox = !this.showFirstLevelEnterpriseBox
    },
    toggleShowDepartmentBox () {
      this.showDepartmentBox = !this.showDepartmentBox
    },
    toggleResearchGroupRemindBox () {
      this.showResearchGroupRemindBox = !this.showResearchGroupRemindBox
    },
    updateFirstLevelEnterprise (enterprise) {
      console.log('enterprise', enterprise)
      this.enterprise = enterprise
      this.department = {}
    },
    updateDepartment (department) {
      console.log('department', department)
      this.department = department
    },
    checkInfo () {
      let _this = this
      if (!_this.registerName) {
        _this.error = '请填写姓名'
        return false
      }
      let mobile = _this.registerMobile.replace(/\s+/g, '')
      if (!mobile) {
        _this.error = '请填写手机号'
        return false
      }
      if (!/^1[3-9]{1}[0-9]{9}$/.test(mobile)) {
        _this.error = '手机号有误'
        return false
      }
      let email = _this.registerEmail.replace(/\s+/g, '')

      if (!email) {
        _this.error = '请填写邮箱'
        return false
      }
      if (!/^\w+([._-]\w+)*@(\w+\.)+\w+$/.test(email)) {
        _this.error = '邮箱有误'
        return false
      }

      if (!_this.enterprise.enterpriseName) {
        _this.error = '请选择单位'
        return false
      }
      // if (_this.ifShowDepartment && !_this.department.enterpriseName) {
      //   _this.error = '请选择科室'
      //   return false
      // }
      if (!_this.agreeStatus) {
        _this.error = '请阅读并同意用户注册协议'
        return false
      }
      return true
    },
    register () {
      var _this = this
      if (!_this.checkInfo()) return $.toast(_this.error)
      this.$weui.loading('正在添加联系人')
      const newContact = {
        'customerName': _this.registerName.replace(/\s/g, ''),
        'mobile': _this.registerMobile.replace(/\s+/g, ''),
        'enterpriseNo': _this.enterprise.enterpriseNo,
        'email': _this.registerEmail.replace(/\s+/g, ''),
        'enterpriseName': _this.enterprise.enterpriseName
      }
      _this.gcapi('registCustomer', newContact).then((response) => {
        this.$weui.loading().hide()
        if (response.body.code === 0 && response.body.result) {
          newContact.customerNo = response.body.result.customerInfo && response.body.result.customerInfo.customerNo
          this.$router.replace({name: 'AddResearchMember', query: {newContact: newContact}})
          this.$weui.toast('联系人添加成功，请选择签约审批原则')
        }
      }, (response) => {
        this.$weui.loading().hide()
        this.$weui.toast(response.body['message'])
      })
    }
  }
}
</script>
<style scoped>
.research_group_container {
  overflow-y:auto;
  overflow-x:hidden;
  /*-webkit-overflow-scrolling:touch;*/
  height:100%;
  width: 100%;
}

.box {
   /*display: flex;*/
   position: absolute;
   align-items: center;
   /*flex-direction: column;*/
   background-color: #efeef3;
   width: 100vw;
   height: 100vh;
   top: 14.93vw;
   left: 0;
 }
.box_1 {
  display: flex;
  /*position: absolute;*/
  align-items: center;
  flex-direction: column;
  background-color: #efeef3;
  width: 100vw;
  /*height: 100vh;*/
  /*top: 0;*/
  /*margin: 6.67vw 0;*/
}
.hd {
  display: flex;
  position: fixed;
  top:0;
  left:0;
  align-items: center;
  flex-direction: row;
  /*background-color: #5878fa;*/
  width: 100vw;
  height: 14.93vw;
  z-index: 10;
  justify-content: center;
}


.navshare {
  position: absolute;
  left: 6.67vw;
  width: 10vw;
  height: 10vw;
  padding-top: 2vw;
  color:#ffffff;
}
.header_title {
  opacity: 1;
  /*margin-left: 29.33vw;*/
  max-width: 60.53vw;
  height: 5.87vw;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 5.87vw;
  white-space: nowrap;
  color: #ffffff;
  font-size: 4.27vw;
  font-weight: 400;
}
.main {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin: 6.67vw 0;
  width: 99.73vw;
}

.outer_3 {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: center;
  border-radius: 2.67vw;
  background-color: #ffffff;
  width: 86.67vw;
  padding: 2vw 0;
}

.outer_attr {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: center;
  background-color: #ffffff;
  width: 86.67vw;
  height:12.8vw;
}

.outer_3 .outer_attr:nth-last-child(2) .empty{
  width: 73.6vw;
  height: 0.53vw;
  border: 0;
}

.empty {
  border-top-width: 0.7px;
  border-top-style: solid;
  border-top-color: rgba(213, 213, 213, 1);
  width: 73.6vw;
  height: 0.53vw;
}
.wrap_approvetype {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  width: 60vw;
  height: 5.33vw;
}
.group {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: 3.47vw;
  padding-right: 6.4vw;
  padding-left: 6.67vw;
  width: 86.67vw;
}

.attr_name {
  opacity: 1;
  width: 7.47vw;
  height: 5.33vw;
  line-height: 5.33vw;
  white-space: nowrap;
  color: #424242;
  font-size: 3.73vw;
  font-weight: 500;
}

.container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 4vw;
  width: 86.4vw;
}

.liveiconput {
  margin-left: 1vw;
  width: 4.5vw;
  height: 4.5vw;
}

.input_text {
  opacity: 1;
  text-align: left;
  line-height: 4.53vw;
  white-space: nowrap;
  color: #929292;
  font-size: 3.73vw;
  font-weight: 400;
  width: 60vw;
  outline: none;
  border: none;
  padding: 0;
}

.ft {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  /* margin-top: 6.67vw; */
  border-radius: 2.67vw;
  /*background-color: #5878fa;*/
  width: 86.67vw;
  height: 13.33vw;
}

.addMember {
  opacity: 1;
  margin-top: 1.07vw;
  max-width: 47.2vw;
  height: 5.33vw;
  overflow: hidden;
  text-align: center;
  text-overflow: ellipsis;
  line-height: 5.33vw;
  white-space: nowrap;
  color: #ffffff;
  font-size: 3.73vw;
  font-weight: 400;
}

input::-webkit-input-placeholder {
  text-align: start;
  color: #D5D5D5;
}

.block_2 {
  display: flex;
  position: relative;
  flex-direction: row;
  align-items: baseline;
  margin-top: 1vw;
  margin-bottom: 7vw;
  width: 86.4vw;
  height: 4.53vw;
  padding-left: 6.67vw;
}

label.label-checkbox input[type=radio]:checked+.item-media i.icon-form-checkbox:after {
  background: no-repeat center;
  background-image: url('/static/img/tick.png');
  background-size: .3rem .22rem;

}
label.label-checkbox input[type=radio]:checked+.item-media i.icon-form-checkbox {
  background-color: #5878fa;
  border: none;
}
label.label-checkbox i.icon-form-checkbox {
  width: .6rem;
  height: .6rem;
}

.desc {
  opacity: 1;
  /*margin-left: 0.8vw;*/
  width: 70.4vw;
  height: 4.53vw;
  line-height: 4.53vw;
  white-space: nowrap;
  color: #929292;
  font-size: 3.2vw;
  font-weight: 400;
}
.agreement {
  /*color: #5878fa;*/
  opacity: 1;
  /*margin-left: 0.8vw;*/
  /*width: 70.4vw;*/
  /*height: 4.53vw;*/
  /*line-height: 4.53vw;*/
  white-space: nowrap;
  font-size: 3.2vw;
  font-weight: 400;
}
</style>



// WEBPACK FOOTER //
// RegisterContact.vue?4d1c797a